import type { IntlShape } from 'react-intl'
import type { InvoiceHeader, InvoiceFormInput } from './types'

export const invoiceHeaders: InvoiceHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun nro.',
				description: 'Invoice number',
			}),
		key: 'id',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nimi / Yritys',
				description: 'Name / Company',
			}),
		key: 'customerName',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Asiakasnumero',
				description: 'Customer number',
			}),
		key: 'customerId',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Due date',
			}),
		key: 'dueDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun summa',
				description: 'Invoice amount',
			}),
		key: 'total',
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const invoiceFormHeaders: InvoiceFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Asiakas',
				description: 'Invoice form input label: Customer',
			}),
		key: 'customer',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksuehto',
				description: 'Invoice form input label: Payment Term',
			}),
		key: 'paymentTerm',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun laji',
				description: 'Invoice form input label: Invoice Type',
			}),
		key: 'invoiceType',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Invoice form input label: Due Date',
			}),
		key: 'dueDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Invoice form input label: Date',
			}),
		key: 'date',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimitustapa',
				description: 'Invoice form input label: Delivery Method',
			}),
		key: 'deliveryMethod',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viitteenne',
				description: 'Invoice form input label: Your Reference',
			}),
		key: 'yourReference',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimituspäivä',
				description: 'Invoice form input label: Delivery Date',
			}),
		key: 'deliveryDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viitteemme',
				description: 'Invoice form input label: Our Reference',
			}),
		key: 'ourReference',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyjä',
				description: 'Invoice form input label: Salesperson',
			}),
		key: 'salesperson',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Varastosta',
				description: 'Invoice form input label: From Stock',
			}),
		key: 'fromStock',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Aputoiminimi',
				description: 'Invoice form input label: Auxiliary Name',
			}),
		key: 'auxiliaryName',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Invoice form input label: Additional Information',
			}),
		key: 'additionalInformation',
		show: true,
		type: 'string',
		fullWidth: true,
	},
]

export const invoiceFormTableHeaders: InvoiceFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Code',
			}),
		key: 'code', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product Name',
			}),
		key: 'productName', //TODO:
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional information',
			}),
		key: 'additionalInformation', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Account',
			}),
		key: 'account', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Cost center',
			}),
		key: 'costCenter', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV',
				description: 'VAT',
			}),
		key: 'vat', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Varastosta',
				description: 'From stock',
			}),
		key: 'fromStock', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määrä',
				description: 'Quantity',
			}),
		key: 'quantity', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'á-hinta',
				description: 'Unit price',
			}),
		key: 'unitPrice', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ale %',
				description: 'Discount %',
			}),
		key: 'discount', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yhteensä',
				description: 'Total',
			}),
		key: 'total', //TODO:
		show: true,
		type: 'number',
	},
]

export const creditInvoiceFormTableHeaders: InvoiceFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Code',
			}),
		key: 'code', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product Name',
			}),
		key: 'productName', //TODO:
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lasku',
				description: 'Invoice',
			}),
		key: 'invoice', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Account',
			}),
		key: 'account', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Cost center',
			}),
		key: 'costCenter', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV',
				description: 'VAT',
			}),
		key: 'vat', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Varastosta',
				description: 'From stock',
			}),
		key: 'fromStock', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määrä',
				description: 'Quantity',
			}),
		key: 'quantity', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'á-hinta',
				description: 'Unit price',
			}),
		key: 'unitPrice', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ale %',
				description: 'Discount %',
			}),
		key: 'discount', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yhteensä',
				description: 'Total',
			}),
		key: 'total', //TODO:
		show: true,
		type: 'number',
	},
]
